import { CartApiResponse, CartStateData } from '../types';

export const formatCartState = (data: CartApiResponse): CartStateData => {
  let drawerSection: HTMLElement | null = null;
  let giftboxCartItems: HTMLUListElement | null = null;
  let giftboxCards: HTMLElement | null = null;
  let giftboxLoyaltyInfo: HTMLElement | null = null;
  let item_count = 0;
  let total_price = '';

  if (data.sections?.['cart-drawer']) {
    drawerSection = new DOMParser()
      .parseFromString(data.sections?.['cart-drawer'], 'text/html')
      .querySelector('cart-drawer');

    item_count = parseInt(drawerSection?.getAttribute('data-quantity') ?? '0');
    total_price = drawerSection?.getAttribute('data-total-price') ?? '';
  }

  if (data.sections?.['giftbox-modal']) {
    const giftboxModalDoc = new DOMParser().parseFromString(
      data.sections?.['giftbox-modal'],
      'text/html',
    );

    giftboxCartItems = giftboxModalDoc.querySelector(
      '[data-giftbox-modal-ref="cart-items"]',
    ) as HTMLUListElement | null;

    giftboxCards = giftboxModalDoc.querySelector('[data-giftbox-modal-ref="giftbox-cards"]');

    giftboxLoyaltyInfo = giftboxModalDoc.querySelector('[data-giftbox-modal-ref="loyalty-info"]');
  }

  const cartData: CartStateData = {
    item_count: item_count,
    total_price: total_price,
    drawerSection: drawerSection,
    giftboxCartItems: giftboxCartItems,
    giftboxCards: giftboxCards,
    giftboxLoyaltyInfo: giftboxLoyaltyInfo,
  };

  return cartData;
};
